module.exports = __webpack_public_path__ + "static/media/ATRIcon.0c19d34a.svg";